import { SHIRT_DEFAULT_MEASUREMENTS } from '@/lib/patterns/shirt/defaults';
import { createGarmentContract } from '@/lib/patterns/contract';
import { buildShirtBlocks } from '@/lib/patterns/shirt/blocks';
import { SHIRT_DISPLAY_OPTIONS } from '@/lib/patterns/shirt/displayOptions';
import {
  generateShirtPatternSIyV1,
  generateShirtPatternSIyV2,
  generateShirtPatternSIyV3,
  recomputeShirtCollarBandV3,
  SHIRT_ACTIVE_FORMULA_VERSION,
  SHIRT_V1_FORMULA_VERSION,
  SHIRT_V2_FORMULA_VERSION,
  SHIRT_V3_FORMULA_VERSION,
  SHIRT_V4_FORMULA_VERSION,
} from '@/lib/patterns/shirt/siy_v1';
import {
  SHIRT_GEOMETRY_V1,
  SHIRT_GEOMETRY_V2,
  SHIRT_GEOMETRY_V3,
  SHIRT_GEOMETRY_V4,
  SHIRT_ACTIVE_GEOMETRY_VERSION,
  resolveShirtFormulaVersionFromGeometry,
  resolveShirtGeometryVersionFromFormula,
  migrateShirtPatternForward,
} from '@/lib/patterns/shirt/version';

export { SHIRT_GEOMETRY_V1, SHIRT_GEOMETRY_V2, SHIRT_GEOMETRY_V3, SHIRT_GEOMETRY_V4, SHIRT_ACTIVE_GEOMETRY_VERSION };

export {
  SHIRT_DEFAULT_MEASUREMENTS,
  SHIRT_ACTIVE_FORMULA_VERSION,
  SHIRT_V1_FORMULA_VERSION,
  SHIRT_V2_FORMULA_VERSION,
  SHIRT_V3_FORMULA_VERSION,
  SHIRT_V4_FORMULA_VERSION,
  recomputeShirtCollarBandV3,
};

export { SHIRT_DISPLAY_OPTIONS };

export { resolveShirtGeometryVersionFromFormula, resolveShirtFormulaVersionFromGeometry, migrateShirtPatternForward };

export function generateShirtPattern(measurements, controls = {}) {
  const geometryVersion = controls.geometryVersion
    || resolveShirtGeometryVersionFromFormula(controls.formulaVersion)
    || SHIRT_ACTIVE_GEOMETRY_VERSION;
  const formulaVersion = resolveShirtFormulaVersionFromGeometry(geometryVersion);

  const generator = geometryVersion === SHIRT_GEOMETRY_V1
    ? generateShirtPatternSIyV1
    : geometryVersion === SHIRT_GEOMETRY_V3 || geometryVersion === SHIRT_GEOMETRY_V4
      ? generateShirtPatternSIyV3
      : generateShirtPatternSIyV2;

  const generated = generator(measurements, {
    ...controls,
    geometryVersion,
    formulaVersion,
  });

  return {
    ...generated,
    formulaVersion,
    geometryVersion,
  };
}

export const computeShirt = generateShirtPattern;

export const SHIRT_CONTRACT = createGarmentContract({
  garment: 'shirt',
  defaults: SHIRT_DEFAULT_MEASUREMENTS,
  compute: computeShirt,
  version: SHIRT_ACTIVE_GEOMETRY_VERSION,
  supportedVersions: [SHIRT_GEOMETRY_V4, SHIRT_GEOMETRY_V3, SHIRT_GEOMETRY_V2, SHIRT_GEOMETRY_V1],
  migrate: migrateShirtPatternForward,
  blocks: buildShirtBlocks,
  displayOptions: SHIRT_DISPLAY_OPTIONS,
});

